import { gql } from "@apollo/client";

export const GEM_PACKAGE_FIELDS_FRAGMENT = gql`
	fragment GemPackageFields on GemPackage {
		id
		name
		title
		subtitle
		gemCount
		price
		description
		image {
			id
			filename
			filepath
			type
			mimetype
			title
			metaData {
				aspectRatio
			}
			uploadedLocs
			imageSizes
		}
		createdAt
		updatedAt
		status
		order
		revenueCatIdentifier
	}
`;
